var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('van-nav-bar',{attrs:{"title":"客户使用指南","left-arrow":"","fixed":"","placeholder":"","safe-area-inset-top":""},on:{"click-left":_vm.goBack}}),_c('iframe',{staticClass:"guide-frame",attrs:{"src":_vm.guideUrl,"title":"客户使用指南"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }